import React  from 'react';
import { SortableContainer } from 'react-sortable-hoc';

function KirokuSortableContainer(props) {
    return <div {...props}/>;
}

export default SortableContainer(KirokuSortableContainer);
